import { Component, OnInit, Input } from '@angular/core';
import { Location } from 'services/location.service'

@Component({
	selector: 'ras-location-thumb',
	templateUrl: './location-thumb.component.html',
	styleUrls: ['./location-thumb.component.sass']
})
export class LocationThumbComponent implements OnInit {

	@Input() location: Location

	constructor() { }

	ngOnInit() {
	}

}
